import React from 'react';
import { gpGetUnreadCount } from 'api/group';

const useGPUnreadCount = (): [number | undefined, boolean, () => void] => {
    const [count, setCount] = React.useState<number | undefined>();
    const [loading, setLoading] = React.useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await gpGetUnreadCount();
            if (!result.error) {
                setCount(result?.data?.data || 0);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };

    React.useEffect(() => {
        if (!loading && count === undefined) {
            fetchData();
        }
    }, []);

    return [count, loading, fetchData];
};

export default useGPUnreadCount;
